/**
 * Created by Ivan on 24.05.2025
 */

const TrumpTutorial = function () {
    return new TutorialScenario(TrumpTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(TrumpTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(TrumpTutorial.NAME);
            Game.currentGame.hand.setCards(TrumpTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(TrumpTutorial.NAME)
    });
};

TrumpTutorial.NAME = "trump";
TrumpTutorial.CONFIG = {
    handValues: ["4"],
    force: "TrumpTutorialMessage"
};
